import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { HoldingsQueryKeys } from "modules/HoldingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { DealerID } from "models";

export type CreateHoldingPayload = {
  id: number;
  name: string;
  dealer_ids: DealerID[];
};

export const useCreateHoldingMutation = () =>
  useTypedMutation<CreateHoldingPayload, number>({
    mutationFn: async payload => (await ApiInstance.post("/holdings/create", payload, ENV.holdingBaseURL)).data.holding_id,
    onSuccess: (payload, holding_id) => {
      const holdings = typedQueryClient.getQueryData(HoldingsQueryKeys.list);

      const holdingIdx = holdings?.findIndex(holding => holding.id === holding_id) ?? -1;
      if (holdingIdx > -1) return;

      const now = toISOString(new Date());

      typedQueryClient.setQueryData(HoldingsQueryKeys.list, [...(holdings ?? []), { ...payload, id: holding_id, created_on: now, updated_on: now }]);
    }
  });
